module.exports = __webpack_public_path__ + "static/media/web-development.0ecd62b7.svg";